import {
  getPlatformName,
  PLATFORM_LOGO_BY_TYPE,
  SOURCE_PLATFORM_TYPE,
} from '@/entities/public-filter/public-filter-constants';
import { Checkbox } from '@/shared/components/shadcn/checkbox';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import { cn } from '@/shared/utils/index';
interface Props {
  value: SOURCE_PLATFORM_TYPE;
  checked: boolean;
  disabled?: boolean;
  onChange?: (platform: SOURCE_PLATFORM_TYPE) => void;
}

export function PlatformCheckbox({ value, checked, disabled, onChange }: Props) {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    onChange?.(value);
  };

  const name = getPlatformName(value);
  const Icon = PLATFORM_LOGO_BY_TYPE[value];
  const content = (
    <div
      className={cn(
        'bg-muted relative flex items-center gap-2 rounded-sm px-2 py-1.5',
        !disabled && 'cursor-pointer',
        disabled && 'cursor-not-allowed opacity-50',
      )}
      onClick={handleClick}
    >
      <Checkbox className="pointer-events-none" checked={checked} disabled={disabled} />
      <div className={cn('flex items-center gap-2')}>
        <Icon className="size-4" />
        <span className="text-popover-foreground text-sm font-medium">{name}</span>
      </div>
    </div>
  );

  if (disabled) {
    return (
      <TooltipFlat asChild content="Coming soon">
        {content}
      </TooltipFlat>
    );
  }

  return content;
}
